import type {VoidFunctionComponent} from "react";
import {useProductMonitoringIdentifyLogic} from "./ProductMonitoringIdentify.logic";

export const ProductMonitoringIdentify: VoidFunctionComponent = () => {
  useProductMonitoringIdentifyLogic();
  return null;
}
